<div class="content-wrapper p-4 animated fadeIn">
  <div class="page-title-box">
    <h4 class="page-title"><i class="fas fa-trash-alt text-danger mr-2"></i> Herramientas de Limpieza: Centros Médicos</h4>
  </div>

  <div class="row">
    <div class="col-md-8 mx-auto">
      <mat-card class="shadow-sm border-0">
        <mat-card-header>
          <mat-card-title>Eliminación Masiva por Gerenciadora</mat-card-title>
          <mat-card-subtitle>Utilizá esta herramienta para limpiar centros médicos importados accidentalmente o duplicados de una gerenciadora específica.</mat-card-subtitle>
        </mat-card-header>

        <mat-card-content class="mt-4">
          <div class="alert alert-warning border-warning">
            <i class="fas fa-exclamation-triangle mr-2"></i> <strong>Atención:</strong> Esta operación es permanente y no se puede deshacer. Se eliminarán todos los centros médicos asociados a la gerenciadora seleccionada.
          </div>

          <div class="mt-4">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Seleccionar Gerenciadora</mat-label>
              <mat-select [(ngModel)]="selectedGerenciadoraId" (selectionChange)="onGerenciadoraChange()">
                <mat-option *ngFor="let g of gerenciadoras" [value]="g._id">
                  {{ g.nombre }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <!-- Counter and Loader -->
          <div class="p-4 bg-light text-center border rounded mt-3" *ngIf="selectedGerenciadoraId">
             <div *ngIf="isLoadingCount">
                <i class="fas fa-spinner fa-spin fa-2x text-primary"></i>
                <p class="mt-2 mb-0">Contando centros asociados...</p>
             </div>
             
             <div *ngIf="!isLoadingCount">
                <h2 class="display-4 font-weight-bold" [class.text-danger]="totalCentros > 0" [class.text-success]="totalCentros === 0">
                  {{ totalCentros }}
                </h2>
                <p class="lead">Centros Médicos asociados actualmente</p>
                <div *ngIf="totalCentros === 0" class="text-success">
                  <i class="fas fa-check-circle"></i> No hay centros registrados para esta gerenciadora.
                </div>
             </div>
          </div>

        </mat-card-content>

        <mat-card-actions class="p-3 d-flex justify-content-end bg-light-gray mt-4 border-top">
          <button mat-button class="mr-3" [routerLink]="['/']"><i class="fas fa-times"></i> Volver</button>
          
          <button mat-raised-button color="warn" 
                  class="btn-xl" 
                  [disabled]="totalCentros === 0 || isLoadingCount || isDeleting"
                  (click)="deleteCentros()">
            <i class="fas fa-trash-alt mr-2"></i> Eliminar Centros Médicos
          </button>
        </mat-card-actions>
      </mat-card>
    </div>
  </div>
</div>
